// import { RenderRichTextData, ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
// import { graphql } from 'gatsby'
// eslint-disable-next-line import/no-cycle
import RichText from '../rich-text'

// export interface Props {
//   title: string
//   body: RenderRichTextData<ContentfulRichTextGatsbyReference>
// }

// export const fragment = graphql`
//   fragment ResourceCallout on ContentfulResourceCallout {
//     __typename
//     contentful_id
//     title
//     body {
//       raw
//       references {
//         ... on ContentfulAsset {
//           gatsbyImage(width: 472)
//         }
//         ...Asset
//         ...HubSpotForm
//       }
//     }
//   }
// `

export default function Callout({ title, body }: Props): JSX.Element {
  return (
    <div className="bg-secondary-50 dark:bg-secondary-800 dark:border-secondary-800 p-8 mb-4 border rounded-[1.125rem] break-inside-avoid">
      <h4 className="text-xl mb-2">{title}</h4>
      <RichText body={body} />
    </div>
  )
}
